import './Footer.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="py-5 text-white">
      <div className="container-fluid px-md-5">
        <div className="row">
          {/* Brand */}
          <div className="col-md-4 mb-3">
            <div
              className="navbar-brand fw-bold fs-3 text-uppercase"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              <span className="brand-highlight">E</span> Commerce
            </div>
            <h6 className="hero-desc my-3">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
              aperiam facilis atque ullam pariatur. Nemo eligendi officiis
              exercitationem officia reprehenderit.
            </h6>
            <div className="d-flex gap-3 mt-4">
              <img src="assets/cms-footer-1.png" alt="" />
              <img src="assets/cms-footer-2.png" alt="" />
            </div>
          </div>

          {/* Links */}
          <div className="col-md-2 col-6 text-center mb-3">
            <h4 className="mb-3">Links</h4>
            <p className="mb-2" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</p>
            <p className="mb-2" onClick={() => navigate("/about")} style={{ cursor: "pointer" }}>About</p>
            <p className="mb-2" onClick={() => navigate("/products")} style={{ cursor: "pointer" }}>Products</p>
            <p className="mb-2" onClick={() => navigate("/contact")} style={{ cursor: "pointer" }}>Contact</p>
          </div>

          {/* Information */}
          <div className="col-md-2 col-6 text-center mb-3">
            <h4 className="mb-3">Information</h4>
            <p className="mb-2" onClick={() => navigate("/return-policy")} style={{ cursor: "pointer" }}>Return Policy</p>
            <p className="mb-2" onClick={() => navigate("/privacy-policy")} style={{ cursor: "pointer" }}>Privacy Policy</p>
            <p className="mb-2" onClick={() => navigate("/refund-policy")} style={{ cursor: "pointer" }}>Refund Policy</p>
            <p className="mb-2" onClick={() => navigate("/agreement")} style={{ cursor: "pointer" }}>Agreement</p>
          </div>

          {/* Top Category */}
          <div className="col-md-2 col-6 text-center mb-3">
            <h4 className="mb-3">Top Category</h4>
            <p className="mb-2" onClick={() => navigate("/category/headphones")} style={{ cursor: "pointer" }}>Wireless headphone</p>
            <p className="mb-2" onClick={() => navigate("/category/speakers")} style={{ cursor: "pointer" }}>Bluetooth speakers</p>
            <p className="mb-2" onClick={() => navigate("/category/devices")} style={{ cursor: "pointer" }}>Portable devices</p>
            <p className="mb-2" onClick={() => navigate("/category/camera")} style={{ cursor: "pointer" }}>Monio live camera</p>
          </div>

          {/* Contact Info */}
          <div className="col-md-2 col-6 text-center mb-3">
            <h4 className="mb-3">Contact Info</h4>
            <p className="mb-2">Phone: +1 234 567 890</p>
            <p className="mb-2">Email: info@domain.com</p>
            <p className="mb-2">
              401 Broadway, 24th floor, orchard view, London, UK
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
